//Everything from the backend, all in one GIANT place.
//Do not modify this file, it's auto-generated using GenerateCSharpObjects.nt


import { ApiService } from 'app/shared/services/api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { NgForm } from '@angular/forms';
import { AppConfigService } from '../services/app-config.service';
import { SignalRService } from '../services/signalR-Service';
import { Tuple } from 'app/core/type-alises'  
 

/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
////////// SignalR service generation ///////////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
@Injectable({providedIn: 'root',})
export class SignalRGlobalMessageService extends SignalRService {
  constructor(public appConfigService: AppConfigService) {
    super(appConfigService)
    this.hubName = 'GlobalMessageHub'
  }
  public notify_register(callbackFunction: (message: GlobalMessageBroadcastResponse) => any){
    super.registerEvent('Notify', callbackFunction)
  }}
@Injectable({providedIn: 'root',})
export class SignalRAdminService extends SignalRService {
  constructor(public appConfigService: AppConfigService) {
    super(appConfigService)
    this.hubName = 'AdminHub'
  }
  public notifyThatUserLoggedOn_register(callbackFunction: (applicationUser: ApplicationUserResponse) => any){
    super.registerEvent('NotifyThatUserLoggedOn', callbackFunction)
  }
  public notifyThatUserLoggedOff_register(callbackFunction: (applicationUser: ApplicationUserResponse) => any){
    super.registerEvent('NotifyThatUserLoggedOff', callbackFunction)
  }
  public notifyOfGroupsInHub_register(callbackFunction: (groupsInHub: Tuple<string,number>) => any){
    super.registerEvent('NotifyOfGroupsInHub', callbackFunction)
  }
  public connect_register(callbackFunction: () => any){
    super.registerEvent('Connect', callbackFunction)
  }}
@Injectable({providedIn: 'root',})
export class SignalRUserService extends SignalRService {
  constructor(public appConfigService: AppConfigService) {
    super(appConfigService)
    this.hubName = 'UserHub'
  }
  public notifyUserOfAccountUpdate_register(callbackFunction: () => any){
    super.registerEvent('NotifyUserOfAccountUpdate', callbackFunction)
  }}

/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////Interface generation section///////////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//#region Interfaces
export interface ObservationsOutsideAgencyResponse{dotNumber: number | null;dOTReadFromDoor: string | null;createdBy: string;createdDate: Date;observedBy: string;observedDate: Date;observedDateUTC: Date;verified: boolean;verifiedBy: string | null;verifiedDate: Date;}
export interface ObservationSearchResponse{observations: ObservationSearchDto[];totalRecords: number;}
export interface ObservationDisplayResponse{observation: ObservationDisplayDto;screenings: ScreeningDto[];imagePaths: string[];}
export interface ScreeningResponse{dOT: string;kYU: string;carrierName: string;}
export interface StatusResponse extends StatusDto{}
export interface ObserverResponse extends ObserverDto{}
export interface ViolationResponse extends ViolationDto{}
export interface ObservationHistoryResponse{observationHistories: ObservationHistoryDto[];}
export interface ObservationImageResponse{imageString: string;}
export interface KyuSearchResponse{id: number;companyName: string | null;dotNumber: number | null;dotReadFromDoor: string | null;kyuNumber: string | null;vehiclePlateNumber: string | null;vehicleWimWeight: number | null;observedDate: Date;observedDateUtc: Date | null;observedBy: string;weighStationName: string;verified: boolean;verifiedBy: string | null;}
export interface CviewPagedResponse{totalRecords: number;pageNumber: number;pageSize: number;totalPages: number;result: CviewSearchResponse[];}
export interface CviewSearchResponse{verified: boolean;dotNumber: number | null;carrierName: string | null;kyuNumber: string | null;licensePlateNumber: string | null;licensePlateState: string | null;weighStationName: string;observedDate: Date;timeZone: string;submitter: string;observationId: number;}
export interface EmailTemplateMetaDataResponse extends EmailTemplateMetaDataDto{}
export interface ObservationSubmitResponse{observationId: number;observedDate: Date;source: string;createdDate: Date;isSuccess: boolean;imageResponse: ObservationImageSubmitResponse[];screeningResponse: ObservationScreeningSubmitResponse[];electronicResponse: ObservationElectronicSubmitResponse[];}
export interface ObservationImageSubmitResponse{imageId: number;imageName: string;}
export interface ObservationScreeningSubmitResponse{screeningId: number;screeningName: string;}
export interface ObservationElectronicSubmitResponse{id: number;agencyID: string;electronicID: string;}
export interface ResultResponse{succeeded: boolean;code: number;result: any;error: ErrorResponse;}
export interface ErrorResponse{code: number;message: string;details: string;}
export interface TypeTableResponse extends TypeTableDto{}
export interface TypeTableMinimalResponse extends BaseEntityDto{name: string;}
export interface ApplicationUserBasicInformationResponse{id: string;firstName: string;lastName: string;email: string;}
export interface ApplicationRoleResponse extends ApplicationRoleDto{}
export interface ExternalAuthenticationSchemeResponse extends ExternalAuthenticationSchemeDto{}
export interface ApplicationUserResponse extends ApplicationUserDto{}
export interface CurrentAuthenticatedUserResponse extends CurrentAuthenticatedUserDto{}
export interface ScreeningTechnologyResponse extends ScreeningTechnologyDto{}
export interface WeighStationCustomResponse extends WeighStationCustomDto{}
export interface WighStationSelectListResponse extends WeighStationSelectListDto{}
export interface PreClearanceSystemResponse extends PreClearanceSystemDto{}
export interface LogResponse extends LogDto{}
export interface GlobalMessageManageResponse extends GlobalMessageResponse{remainingActiveTime: string;}
export interface GlobalMessageBroadcastResponse{severity: string;summary: string;detail: string | null;}
export interface UserAuthorizedApplicationsResponse extends UserAuthorizedApplicationsDto{redirectUriList: string[];redirectUrl: string;}
export interface OpenIddictClientResponse extends OpenIddictClientDto{}
export interface ReportRedirectUrlResponse{reportUrl: string;}
export interface ApplicationInfoResponse{environmentInfo: EnvironmentInformationDto;}
export interface ApiResponse<T>{succeeded: boolean;code: number;result: T;errors: ApiErrorMessageResponse[];}
export interface ApiMessageResponse{message: string;type: string;}
export interface ApiUrlResponse extends ApiMessageResponse{}
export interface ApiErrorMessageResponse extends ApiMessageResponse{}
export interface ApiValidationErrorResponse extends ApiErrorMessageResponse{}
export interface VendorApiUserKeyFullResponse extends VendorApiUserKeyFullDto{}
export interface VendorApiUserKeyResponse{id: number;userId: string;key: string;}
export interface WeighStationToTypePreClearanceSystemFullResponse extends WeighStationToTypePreClearanceSystemFullDto{}
export interface WeighStationToTypePreClearanceSystemResponse{id: number;weighStationId: number;typePreClearanceSystemId: number;weighStation: WeighStationResponse;typePreClearanceSystem: TypeTableEntityResponse;}
export interface WeighStationToTypeScreeningTechnologyFullResponse extends WeighStationToTypeScreeningTechnologyFullDto{}
export interface WeighStationToTypeScreeningTechnologyResponse{id: number;weighStationId: number;typeScreeningTechnologyId: number;weighStation: WeighStationResponse;typeScreeningTechnology: TypeTableEntityResponse;}
export interface WeighStationFullResponse extends WeighStationFullDto{}
export interface WeighStationResponse{id: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;typeCounty: TypeTableEntityResponse;typeLocation: TypeTableEntityResponse;}
export interface TypeTableEntityFullResponse extends TypeTableEntityFullDto{}
export interface TypeTableEntityResponse{id: number;name: string;sortOrder: number;immutable: boolean;}
export interface EmailLogFullResponse extends EmailLogFullDto{}
export interface EmailLogResponse{id: number;subject: string;body: string;toAddress: string;attachments: string;}
export interface WeighStationHistoryFullResponse extends WeighStationHistoryFullDto{}
export interface WeighStationHistoryResponse{id: number;entityId: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;typeCounty: TypeTableEntityResponse;typeLocation: TypeTableEntityResponse;}
export interface ObservationHistoryFullResponse extends ObservationHistoryFullDto{}
export interface ObservationHistoryResponse{id: number;entityId: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;typeSource: TypeTableEntityResponse;weighStation: WeighStationResponse;typeCounty: TypeTableEntityResponse;typeJurisdiction: TypeTableEntityResponse;typeObserver: TypeTableEntityResponse;}
export interface ObservationFullResponse extends ObservationFullDto{}
export interface ObservationResponse{id: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;typeSource: TypeTableEntityResponse;weighStation: WeighStationResponse;typeCounty: TypeTableEntityResponse;typeJurisdiction: TypeTableEntityResponse;typeObserver: TypeTableEntityResponse;}
export interface ObservationScreeningFullResponse extends ObservationScreeningFullDto{}
export interface ObservationScreeningResponse{id: number;observationId: number;typeStatusId: number;typeViolationId: number;message: string;observation: ObservationResponse;typeStatus: TypeTableEntityResponse;typeViolation: TypeTableEntityResponse;}
export interface ObservationImageFullResponse extends ObservationImageFullDto{}
export interface ObservationImageResponse{id: number;observationId: number;name: string;description: string;path: string;observation: ObservationResponse;}
export interface ObservationElectronicFullResponse extends ObservationElectronicFullDto{}
export interface ObservationElectronicResponse{id: number;observationId: number;agencyId: string;electronicId: string;observation: ObservationResponse;}
export interface GlobalMessageFullResponse extends GlobalMessageFullDto{}
export interface GlobalMessageResponse{id: number;severity: string;summary: string;detail: string | null;startDateTime: Date;endDateTime: Date;}
export interface EmailTemplateFullResponse extends EmailTemplateFullDto{}
export interface EmailTemplateResponse{id: number;name: string;content: string;type: string;}
export interface EntitySnapshotDto<T>{entity: T;periodStart: Date;periodEnd: Date;}
export interface ScreeningDto{screeningType: string;status: string;message: string;}
export interface ObserverDto{id: number;name: string;}
export interface ObservationHistoryDto{id: number;createdBy: string;createdDate: string;changedFields: ObservationHistoryChangedFieldDto[];}
export interface ObservationHistoryChangedFieldDto{fieldName: string;oldValue: string;newValue: string;}
export interface ViolationDto{id: number;name: string;}
export interface ObservationSearchDto{id: number;companyName: string | null;dotNumber: number | null;kyuNumber: string | null;vehiclePlateNumber: string | null;observedDate: Date;observedBy: string;weighStationName: string;verified: boolean;}
export interface ObservationUpdateDto{id: number;dotNumber: number | null;kyuNumber: number | null;vehiclePlateNumber: string | null;typeJurisdictionId: number | null;bad: boolean;verified: boolean;companyName: string | null;}
export interface StatusDto{id: number;name: string;}
export interface ObservationDisplayDto{id: number;dotNumber: number | null;kyuNumber: string | null;vehiclePlateNumber: string | null;typeJurisdictionId: number | null;companyName: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;vehicleGrossWeight: number | null;vehicleWimWeight: number | null;weighStationId: number | null;weighStationName: string | null;countyName: string | null;routePrefix: string | null;routeNumber: number | null;routeSuffix: string | null;routeMilepoint: number | null;latitude: number | null;longitude: number | null;observedBy: string;observedDate: Date;observedDateUtc: Date;updatedBy: string;updatedDate: Date;verified: boolean;bad: boolean | null;}
export interface HealthCheckNotificationPayloadDto{message: string;}
export interface EmailTemplateMetaDataDto{id: number;name: string;content: string;updatedByName: string;updatedDate: Date;isActive: boolean;type: string;}
export interface TypeTableFullDto extends BaseFullEntityDto{name: string;sortOrder: number;immutable: boolean;}
export interface TypeTableDto extends BaseEntityDto{name: string;sortOrder: number;}
export interface ExternalAuthenticationSchemeDto{name: string;displayName: string | null;}
export interface ApplicationRoleDto{id: string;name: string;}
export interface ApplicationUserDto{id: string;firstName: string;lastName: string;email: string;roles: ApplicationRoleDto[];typeUserAccountStatus: TypeTableDto;isActive: boolean;}
export interface CurrentAuthenticatedUserDto{userId: string;email: string;firstName: string;lastName: string;typeUserAccountStatusId: number;isAuthenticatedFromActiveDirectory: boolean;isActive: boolean;roles: string[];}
export interface WeighStationSelectListDto{id: number;name: string;}
export interface ScreeningTechnologyDto{id: number;name: string;}
export interface WeighStationCustomDto{id: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;isActive: boolean;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;preClearanceSystems: PreClearanceSystemDto[];screeningTechnologies: ScreeningTechnologyDto[];}
export interface PreClearanceSystemDto{id: number;name: string;}
export interface LogDto{id: number;message: string | null;level: string | null;timeStamp: Date;exception: string | null;logEvent: string | null;}
export interface OpenIddictClientDto{id: string;clientId: string;applicationDisplayName: string;redirectUris: string;postLogoutRedirectUris: string;}
export interface UserAuthorizedApplicationsDto{applicationDisplayName: string;redirectUris: string;}
export interface EnvironmentInformationDto{oS: string;machineName: string;environmentName: string;runtimeFramework: string;}
export interface BaseEntityDto{id: number;}
export interface BaseFullEntityDto{id: number;createdBy: string;createdDate: Date | null;updatedBy: string | null;updatedDate: Date | null;isActive: boolean;}
export interface TypeTableEntityDto{id: number;name: string;sortOrder: number;immutable: boolean;}
export interface VendorApiUserKeyFullDto extends BaseFullEntityDto{userId: string;key: string;}
export interface VendorApiUserKeyDto extends BaseEntityDto{userId: string;key: string;}
export interface WeighStationToTypePreClearanceSystemFullDto extends BaseFullEntityDto{weighStationId: number;typePreClearanceSystemId: number;weighStation: WeighStationDto;typePreClearanceSystem: TypeTableEntityDto;}
export interface WeighStationToTypePreClearanceSystemDto extends BaseEntityDto{weighStationId: number;typePreClearanceSystemId: number;weighStation: WeighStationDto;typePreClearanceSystem: TypeTableEntityDto;}
export interface WeighStationToTypeScreeningTechnologyFullDto extends BaseFullEntityDto{weighStationId: number;typeScreeningTechnologyId: number;weighStation: WeighStationDto;typeScreeningTechnology: TypeTableEntityDto;}
export interface WeighStationToTypeScreeningTechnologyDto extends BaseEntityDto{weighStationId: number;typeScreeningTechnologyId: number;weighStation: WeighStationDto;typeScreeningTechnology: TypeTableEntityDto;}
export interface WeighStationFullDto extends BaseFullEntityDto{refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;typeCounty: TypeTableEntityDto;typeLocation: TypeTableEntityDto;weighStationToPreClearanceSystems: WeighStationToTypePreClearanceSystemDto[];weighStationToScreeningTechnologies: WeighStationToTypeScreeningTechnologyDto[];observations: ObservationDto[];}
export interface WeighStationDto extends BaseEntityDto{refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;typeCounty: TypeTableEntityDto;typeLocation: TypeTableEntityDto;weighStationToPreClearanceSystems: WeighStationToTypePreClearanceSystemDto[];weighStationToScreeningTechnologies: WeighStationToTypeScreeningTechnologyDto[];observations: ObservationDto[];}
export interface TypeTableEntityFullDto extends BaseFullEntityDto{name: string;sortOrder: number;immutable: boolean;}
export interface TypeTableEntityDto extends BaseEntityDto{name: string;sortOrder: number;immutable: boolean;}
export interface EmailLogFullDto extends BaseFullEntityDto{subject: string;body: string;toAddress: string;attachments: string;}
export interface EmailLogDto extends BaseEntityDto{subject: string;body: string;toAddress: string;attachments: string;}
export interface WeighStationHistoryFullDto extends BaseFullEntityDto{entityId: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;typeCounty: TypeTableEntityDto;typeLocation: TypeTableEntityDto;weighStationToPreClearanceSystems: WeighStationToTypePreClearanceSystemDto[];weighStationToScreeningTechnologies: WeighStationToTypeScreeningTechnologyDto[];observations: ObservationDto[];}
export interface WeighStationHistoryDto extends BaseEntityDto{entityId: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;typeCounty: TypeTableEntityDto;typeLocation: TypeTableEntityDto;weighStationToPreClearanceSystems: WeighStationToTypePreClearanceSystemDto[];weighStationToScreeningTechnologies: WeighStationToTypeScreeningTechnologyDto[];observations: ObservationDto[];}
export interface ObservationHistoryFullDto extends BaseFullEntityDto{entityId: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;typeSource: TypeTableEntityDto;weighStation: WeighStationDto;typeCounty: TypeTableEntityDto;typeJurisdiction: TypeTableEntityDto;typeObserver: TypeTableEntityDto;}
export interface ObservationHistoryDto extends BaseEntityDto{entityId: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;typeSource: TypeTableEntityDto;weighStation: WeighStationDto;typeCounty: TypeTableEntityDto;typeJurisdiction: TypeTableEntityDto;typeObserver: TypeTableEntityDto;}
export interface ObservationFullDto extends BaseFullEntityDto{refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;typeSource: TypeTableEntityDto;weighStation: WeighStationDto;typeCounty: TypeTableEntityDto;typeJurisdiction: TypeTableEntityDto;typeObserver: TypeTableEntityDto;}
export interface ObservationDto extends BaseEntityDto{refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;typeSource: TypeTableEntityDto;weighStation: WeighStationDto;typeCounty: TypeTableEntityDto;typeJurisdiction: TypeTableEntityDto;typeObserver: TypeTableEntityDto;}
export interface ObservationScreeningFullDto extends BaseFullEntityDto{observationId: number;typeStatusId: number;typeViolationId: number;message: string;observation: ObservationDto;typeStatus: TypeTableEntityDto;typeViolation: TypeTableEntityDto;}
export interface ObservationScreeningDto extends BaseEntityDto{observationId: number;typeStatusId: number;typeViolationId: number;message: string;observation: ObservationDto;typeStatus: TypeTableEntityDto;typeViolation: TypeTableEntityDto;}
export interface ObservationImageFullDto extends BaseFullEntityDto{observationId: number;name: string;description: string;path: string;observation: ObservationDto;}
export interface ObservationImageDto extends BaseEntityDto{observationId: number;name: string;description: string;path: string;observation: ObservationDto;}
export interface ObservationElectronicFullDto extends BaseFullEntityDto{observationId: number;agencyId: string;electronicId: string;observation: ObservationDto;}
export interface ObservationElectronicDto extends BaseEntityDto{observationId: number;agencyId: string;electronicId: string;observation: ObservationDto;}
export interface GlobalMessageFullDto extends BaseFullEntityDto{severity: string;summary: string;detail: string | null;startDateTime: Date;endDateTime: Date;}
export interface GlobalMessageDto extends BaseEntityDto{severity: string;summary: string;detail: string | null;startDateTime: Date;endDateTime: Date;}
export interface EmailTemplateFullDto extends BaseFullEntityDto{name: string;content: string;type: string;}
export interface EmailTemplateDto extends BaseEntityDto{name: string;content: string;type: string;}
export interface ObservationSearchRequest{dOT: number | null;kYU: number | null;plate: string | null;jurisdictionId: number | null;fromDate: Date;toDate: Date;weighstationId: number | null;observerId: number | null;errorTypeId: number | null;selectedBadOptions: string[];selectedVerifiedOptions: string[];violationTypeId: number | null;inspectionId: number | null;}
export interface ObservationUpdateRequest extends ObservationUpdateDto{}
export interface KATSObservationRequest{observationId: string;weighStationCode: number;observedBy: string;observedDate: Date;companyName: string | null;confidence: number | null;dotAssociatedToKyu: string | null;dotNumber: number | null;dotReadFromDoor: string | null;dotStatus: string | null;foosCode: number | null;inspectionId: number | null;issScore: number | null;kyuNumber: string | null;latitude: number;longitude: number;mcrsDotplateRead: string | null;mcsipLevel: number | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;routeCounty: string | null;routeMilepoint: number | null;routeNumber: number | null;routeWeightClass: string | null;t31Dba: string | null;t31IssScore: number | null;tpdSAnomaly: boolean | null;tpdsDate: Date | null;tpdSid: number | null;tpdSSource: string | null;vehicleGrossWeight: number | null;vehicleMake: string | null;vehicleModel: string | null;vehicleNumber: string | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleWimWeight: number | null;vehicleYear: number | null;vehiclePlateState: string | null;verified: boolean;verifiedBy: string | null;verifiedDate: Date | null;screenings: ScreeningRequest[] | null;images: ImageRequest[] | null;electronicID: ElectronicRequest[] | null;}
export interface ScreeningRequest{name: string;message: string;status: string;}
export interface ImageRequest{name: string;description: string;bytes: number[];}
export interface ImageReplaceRequest extends ImageRequest{observationId: string;}
export interface ElectronicRequest{agencyID: string;electronicID: string;}
export interface DrivewyzeObservationRequest{observedDate: Date | null;carrier: string | null;dOTNumber: number | null;licensePlate: string | null;kYUNumber: number | null;alert: string | null;clearanceResult: string;drivewyzeWeighStationName: string | null;}
export interface CviewRequest{dotNumber: number | null;kyuNumber: number | null;licensePlateNumber: string | null;licensePlateState: string | null;fromDate: Date | null;toDate: Date | null;sortField: string | null;sortDirection: string | null;pageNumber: number | null;pageSize: number | null;}
export interface PrePassObservationRequest{dOTNumber: number | null;kYUNumber: number | null;licensePlate: string | null;jurisdiction: string | null;prepassSiteValue: string | null;observedDate: Date | null;}
export interface TypeTableUpdateRequest extends TypeTableCreateRequest{id: number;}
export interface TypeTableCreateRequest{name: string;sortOrder: number;}
export interface ApplicationUserExternalUserRegisterRequest extends ApplicationUserCreateRequest{returnUrl: string;}
export interface ApplicationUserCreateRequest{id: string;firstName: string;lastName: string;email: string;createdBy: string | null;roleIds: string[] | null;}
export interface ApplicationUserUpdateRequest{id: string;firstName: string;lastName: string;email: string;typeUserAccountStatusId: number;}
export interface ApplicationUserWithRolesUpdateRequest extends ApplicationUserUpdateRequest{roles: ApplicationRoleDto[];}
export interface WeighStationCustomUpdateRequest extends WeighStationCustomDto{}
export interface WeighStationCustomCreateRequest extends WeighStationCustomDto{}
export interface OpenIddictClientCreateRequest{clientId: string;applicationDisplayName: string;redirectUris: string;postLogoutRedirectUris: string;}
export interface OpenIddictClientUpdateRequest extends OpenIddictClientDto{}
export interface Get_ThrowBadRequest{}
export interface VendorApiUserKeyCreateRequest{userId: string;key: string;}
export interface VendorApiUserKeyUpdateRequest{id: number;userId: string;key: string;}
export interface WeighStationToTypePreClearanceSystemCreateRequest{weighStationId: number;typePreClearanceSystemId: number;}
export interface WeighStationToTypePreClearanceSystemUpdateRequest{id: number;weighStationId: number;typePreClearanceSystemId: number;}
export interface WeighStationToTypeScreeningTechnologyCreateRequest{weighStationId: number;typeScreeningTechnologyId: number;}
export interface WeighStationToTypeScreeningTechnologyUpdateRequest{id: number;weighStationId: number;typeScreeningTechnologyId: number;}
export interface WeighStationCreateRequest{refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;weighStationToPreClearanceSystems: WeighStationToTypePreClearanceSystemCreateRequest[];weighStationToScreeningTechnologies: WeighStationToTypeScreeningTechnologyCreateRequest[];observations: ObservationCreateRequest[];}
export interface WeighStationUpdateRequest{id: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;}
export interface TypeTableEntityCreateRequest{name: string;sortOrder: number;immutable: boolean;}
export interface TypeTableEntityUpdateRequest{id: number;name: string;sortOrder: number;immutable: boolean;}
export interface EmailLogCreateRequest{subject: string;body: string;toAddress: string;attachments: string;}
export interface EmailLogUpdateRequest{id: number;subject: string;body: string;toAddress: string;attachments: string;}
export interface WeighStationHistoryCreateRequest{entityId: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;weighStationToPreClearanceSystems: WeighStationToTypePreClearanceSystemCreateRequest[];weighStationToScreeningTechnologies: WeighStationToTypeScreeningTechnologyCreateRequest[];observations: ObservationCreateRequest[];}
export interface WeighStationHistoryUpdateRequest{id: number;entityId: number;refGuid: string | null;code: number;name: string;typeCountyId: number;distance: number;routePrefix: string;routeNumber: number;routeSuffix: string;routeMilepoint: number;latitude: number | null;longitude: number | null;operational: boolean;phoneNumber: string | null;prepassSiteValue: string | null;drivewyzeSiteValue: string | null;typeLocationId: number;}
export interface ObservationHistoryCreateRequest{entityId: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;}
export interface ObservationHistoryUpdateRequest{id: number;entityId: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;}
export interface ObservationCreateRequest{refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;}
export interface ObservationUpdateRequest{id: number;refGuid: string | null;vendorId: string | null;typeSourceId: number | null;weighStationId: number | null;dotNumber: number | null;kyuNumber: number | null;companyName: string | null;sourceVerified: boolean;verified: boolean;confidence: number | null;estimatedMiles: number | null;dotStatus: string | null;issScore: number | null;mcsipLevel: number | null;foosCode: number | null;routeNumber: number | null;typeCountyId: number | null;routeMilepoint: number | null;routeWeightClass: string | null;latitude: number | null;longitude: number | null;vehicleNumber: string | null;vehicleGrossWeight: number | null;typeJurisdictionId: number | null;vehiclePlateNumber: string | null;vehicleVin: string | null;vehicleMake: string | null;vehicleModel: string | null;vehicleYear: number | null;typeObserverId: number;observedDate: Date;verifiedBy: string | null;verifiedDate: Date | null;sourceBad: boolean;bad: boolean;clearanceResult: string | null;observedDateUtc: Date | null;dotReadFromDoor: string | null;dotAssociatedToKyu: string | null;mcrsDotplateRead: string | null;rescreenDate: Date | null;rescreenDot: string | null;rescreenKyu: string | null;rescreenPlate: string | null;rescreenState: string | null;inspectionId: number | null;t31Dba: string | null;t31IssScore: number | null;vehicleWimWeight: number | null;tpdSid: number | null;tpdsDate: Date | null;tpdSAnomaly: boolean;tpdSSource: string | null;}
export interface ObservationScreeningCreateRequest{observationId: number;typeStatusId: number;typeViolationId: number;message: string;}
export interface ObservationScreeningUpdateRequest{id: number;observationId: number;typeStatusId: number;typeViolationId: number;message: string;}
export interface ObservationImageCreateRequest{observationId: number;name: string;description: string;path: string;}
export interface ObservationImageUpdateRequest{id: number;observationId: number;name: string;description: string;path: string;}
export interface ObservationElectronicCreateRequest{observationId: number;agencyId: string;electronicId: string;}
export interface ObservationElectronicUpdateRequest{id: number;observationId: number;agencyId: string;electronicId: string;}
export interface GlobalMessageCreateRequest{severity: string;summary: string;detail: string | null;startDateTime: Date;endDateTime: Date;}
export interface GlobalMessageUpdateRequest{id: number;severity: string;summary: string;detail: string | null;startDateTime: Date;endDateTime: Date;}
export interface EmailTemplateCreateRequest{name: string;content: string;type: string;}
export interface EmailTemplateUpdateRequest{id: number;name: string;content: string;type: string;}
//#endregion

/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////Constants generation section///////////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//#region Constants
export const LoginFailureConstants={requiresTwoFactor: 'RequiresTwoFactor',accountLockedOut: 'AccountLockedOut',invalidAuthenticatorCode: 'InvalidAuthenticatorCode',}
export const GlobalMessagingSeverityConstants={success: 'Success',info: 'Info',warn: 'Warn',error: 'Error',}
export const GlobalMessagingEventsConstants={successToast: 'SuccessToast',successNotification: 'SuccessNotification',errorToast: 'ErrorToast',errorNotification: 'ErrorNotification',}
export const SignalRGroupConstants={admin: 'Admin',user: 'User',}
export const UIMesssageConstants={validationErrorGeneric: 'Validation errors',genericException: 'There was a problem processing the request',genericUnauthorized: 'Unauthorized reqest',genericFailure: 'Failure',genericSuccess: 'Success',userUpdateSuccessGeneric: 'User successfully updated',userUpdateErrorGeneric: 'There was a problem updating the user',accountRequested: 'You have successfully requested access, an administrator must approve your request before you can continue into the system',}
export const ValidationMessageConstants={globalMessageValidatorDate: 'Start Date cannot come after End Date',observationSearchValidatorDate: 'From Date must come before To Date',observationSearchValidatorDateRange: 'Search range limited to one year',screeningStatus: 'Screening Status Must be Error, Fail, Fault, Pass,Warn',}
export const HttpVerbConstants={get: 'GET',post: 'POST',put: 'PUT',delete: 'DELETE',}
export const EnvironmentConstants={production: 'Production',development: 'Development',localDevelopment: 'Local Development',}
export const SearchConstants={dot: 'dotnumber',kyu: 'kyunumber',plateNumber: 'licenseplatenumber',plateJurisdiction: 'licenseplatestate',observedDate: 'observeddate',}
export const SortingConstants={asc: 'asc',desc: 'desc',ascending: 'ascending',descending: 'descending',}
export const RoleConstants={superAdmin: 'Super Admin',admin: 'Admin',manageUsers: 'Manage Users',manageWeighStations: 'Manage Weigh Stations',editObservation: 'Edit Observation',readOnly: 'Read Only',}
export const AuthorizationPolicyConstants={activeUserPolicy: 'ActiveUserPolicy',superAdminOnlyPolicy: 'SuperAdminOnlyPolicy ',}
export const TypeTableConstants={typeSource: 'TypeSource',typeCounty: 'TypeCounty',typeDistrict: 'TypeDistrict',typeJurisdiction: 'TypeJurisdiction',typeLocation: 'TypeLocation',typeUserAccountStatus: 'TypeUserAccountStatus',typeTimeZone: 'TypeTimeZone',typeStatus: 'TypeStatus',typeViolation: 'TypeViolation',typePreClearanceSystem: 'TypePreClearanceSystem',typeScreeningTechnology: 'TypeScreeningTechnology',typeObserver: 'TypeObserver',}
export const EmailTemplateConstants={base: 'Base.html',basic: 'Basic.html',confirmation: 'Confirmation.html',confirmEmailChange: 'ConfirmEmailChange.html',notifyOfEmailChange: 'NotifyOfEmailChange.html',resetPassword: 'ResetPassword.html',accountCreatedFromAdmin: 'AccountCreatedFromAdmin.html',healthCheckNotificationPayloadNotification: 'HealthCheckNotificationPayloadNotification.html',userRequestAccess: 'User Request Access',applicationUserStatusApproved: 'ApplicationUserStatusApproved',applicationUserStatusDenied: 'ApplicationUserStatusDenied',}
export const CustomClaimTypesConstants={sSOUserProfileId: 'SSOUserProfileId',typeUserStatusName: 'TypeUserStatusName',typeUserStatusId: 'TypeUserStatusId',needToUpdateUserAccountFromSso: 'NeedToUpdateUserAccountFromSso',externalLogin: 'ExternalLogin',isActive: 'IsActive',displayName: 'Displayname',name: 'name',}
export const DatabaseSchemaConstants={type: 'Type',admin: 'Admin',identity: 'Identity',openIddict: 'OpenIddict',history: 'History',defaultSchema: 'dbo',}
export const HealthCheckConstants={system: 'System',jobs: 'Jobs',notCritical: 'Not Critical',services: 'Services',}
//#endregion

/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////////Enums generation section///////////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//#region Enums
export enum LogApplicationEvents{PerformanceWarning = 1000,}
export enum LogEmailEvents{EmailSent = 2000,EmailFailedToSend = 2001,}
export enum LogEntityCrudEvents{EntityCreated = 3000,EntityUpdated = 3001,EntityDeactivated = 3002,EntityHardDeleted = 3003,}
export enum LogBasic{ThrowWarning = 4000,ThrowError = 4001,ThrowCritical = 4002,}
export enum LogUserEvents{UserLoggedIn = 5000,LockedOutUserAttemptedLogin = 5001,UserNotFoundByEmailOnLogin = 5002,UserTriedToLoginWithoutAConfirmedEmail = 5003,UserTriedToUpdateAUserOtherThanThemselves = 5004,UserEnabled2fa = 5005,UserLoggedInWith2fa = 5006,UserTriedToLoginWithInvalid2faAuthenticationCode = 5007,UserNotFoundDuring2faLogin = 5008,UserNotFoundByEmailForPasswordReset = 5009,UserResetPasswordFailure = 5010,UserResetPassword = 5011,UserEmailNotConfirmedForPasswordReset = 5012,UserFailedToLoginWithExternalProvider = 5013,ErrorResettingPassword = 5014,ExternalUserRegistered = 5015,ExternalUserLoggedButHasNoAccount = 5016,UserPasswordRequest = 5017,UserRequestedConfirmirationEmail = 5018,EmailConfirmationFailure = 5019,}
export enum BackgroundJobEvents{JobStarted = 6000,GlobalMessages = 6001,}
export enum SignalREvents{UserDisconnectedWithException = 7000,GlobalMessages = 7001,}
export enum EmailTemplateEnum{Base = 1,Basic = 2,HealthCheckNotificationPayloadNotification = 3,UserRequestAccess = 4,ApplicationUserStatusApproved = 5,ApplicationUserStatusDenied = 6,}
export enum EnumTypeUserAccountStatus{Active = 1,Pending = 2,Denied = 3,Inactive = 4,}
export enum EnumTypeLocation{Fixed = 1,Virtual = 2,}
export enum EnumTypeTimeZone{Central = 1,Eastern = 2,}
export enum EnumTypeSource{Manual = 1,Automated = 2,}
export enum EnumTypeObserver{ALTS = 1,DriveWyze = 2,inSPECT = 3,KATS = 4,PrePass = 5,}
export enum EnumTypeStatus{Error = 1,Fail = 2,Fault = 3,Pass = 4,Warn = 5,}
export enum EnumDataServiceMessages{Success = 100,Unknown = 101,MissingRequired = 102,MissingObserveBy = 103,MissingObservedDate = 104,}
//#endregion

/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////Controller service generation section//////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//#region Controller services
﻿
@Injectable({
  providedIn: 'root',
})
export class TypePreClearanceSystemControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypePreClearanceSystem/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypePreClearanceSystem/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypePreClearanceSystem/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypePreClearanceSystem/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypePreClearanceSystem/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypePreClearanceSystem/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypePreClearanceSystem/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypePreClearanceSystem/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypePreClearanceSystem/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypePreClearanceSystem/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeObserverControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeObserver/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeObserver/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeObserver/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeObserver/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeObserver/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeObserver/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeObserver/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeObserver/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeObserver/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeObserver/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeLocationControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeLocation/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeLocation/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeLocation/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeLocation/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeLocation/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeLocation/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeLocation/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeLocation/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeLocation/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeLocation/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeCountyControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeCounty/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeCounty/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeCounty/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeCounty/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeCounty/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeCounty/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeCounty/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeCounty/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeCounty/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeCounty/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeJurisdictionControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeJurisdiction/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeJurisdiction/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeJurisdiction/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeJurisdiction/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeJurisdiction/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeJurisdiction/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeJurisdiction/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeJurisdiction/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeJurisdiction/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeJurisdiction/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeSourceControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeSource/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeSource/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeSource/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeSource/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeSource/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeSource/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeSource/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeSource/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeSource/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeSource/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeScreeningTechnologyControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeScreeningTechnology/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeScreeningTechnology/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeScreeningTechnology/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeScreeningTechnology/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeScreeningTechnology/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeScreeningTechnology/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeScreeningTechnology/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeScreeningTechnology/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeScreeningTechnology/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeScreeningTechnology/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeStatusControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeStatus/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeStatus/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeStatus/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeStatus/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeStatus/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeStatus/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeStatus/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeStatus/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeStatus/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeStatus/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeDistrictControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeDistrict/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeDistrict/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeDistrict/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeDistrict/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeDistrict/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeDistrict/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeDistrict/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeDistrict/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeDistrict/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeDistrict/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeViolationControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeViolation/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeViolation/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeViolation/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeViolation/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeViolation/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeViolation/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeViolation/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeViolation/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeViolation/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeViolation/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeUserAccountStatusControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public createFakeData_post(numberOfFakes: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeUserAccountStatus/CreateFakeData?numberOfFakes=${numberOfFakes}`,
              HttpVerbConstants.post, null, form);
            }
    
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeUserAccountStatus/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeUserAccountStatus/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeUserAccountStatus/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeUserAccountStatus/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeUserAccountStatus/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeUserAccountStatus/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeUserAccountStatus/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeUserAccountStatus/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeUserAccountStatus/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeUserAccountStatus/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class TypeTimeZoneControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getMinimal_get(): Observable<ApiResponse<TypeTableMinimalResponse[]>> {       
          return this.apiService.execute<TypeTableMinimalResponse[]>( 
              `api/TypeTimeZone/GetMinimal`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: TypeTableUpdateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeTimeZone/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: TypeTableCreateRequest, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeTimeZone/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeTimeZone/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeTimeZone/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeTimeZone/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<TypeTableFullDto[]>> {       
          return this.apiService.execute<TypeTableFullDto[]>( 
              `api/TypeTimeZone/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<TypeTableResponse[]>> {       
          return this.apiService.execute<TypeTableResponse[]>( 
              `api/TypeTimeZone/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<TypeTableFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<TypeTableFullDto>[]>( 
              `api/TypeTimeZone/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<TypeTableResponse>> {       
          return this.apiService.execute<TypeTableResponse>( 
              `api/TypeTimeZone/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class ScreeningTechnologyControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllScreeningTechnologies_get(): Observable<ApiResponse<ScreeningTechnologyResponse[]>> {       
          return this.apiService.execute<ScreeningTechnologyResponse[]>( 
              `api/ScreeningTechnology/GetAllScreeningTechnologies`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class PreClearanceSystemControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllPreClearanceSystems_get(): Observable<ApiResponse<PreClearanceSystemResponse[]>> {       
          return this.apiService.execute<PreClearanceSystemResponse[]>( 
              `api/PreClearanceSystem/GetAllPreClearanceSystems`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class WeighStationControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllWeighStations_get(): Observable<ApiResponse<WeighStationCustomResponse[]>> {       
          return this.apiService.execute<WeighStationCustomResponse[]>( 
              `api/WeighStation/GetAllWeighStations`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getWeighStationsForSelectList_get(): Observable<ApiResponse<WighStationSelectListResponse[]>> {       
          return this.apiService.execute<WighStationSelectListResponse[]>( 
              `api/WeighStation/GetWeighStationsForSelectList`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public createWeighStation_post(weighStationCreateRequest: WeighStationCustomCreateRequest, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/CreateWeighStation`,
              HttpVerbConstants.post, weighStationCreateRequest, form);
            }
    
  
    
    
  
      
  
      public updateWeighStation_put(weighStationUpdateRequest: WeighStationCustomUpdateRequest, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/UpdateWeighStation`,
              HttpVerbConstants.put, weighStationUpdateRequest, form);
            }
    
  
    
    
  
      
  
      public deleteWeighStation_delete(weighStationId: number, form?: NgForm): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/WeighStation/DeleteWeighStation?weighStationId=${weighStationId}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivateWeighStation_put(id: number, form?: NgForm): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/WeighStation/ReactivateWeighStation/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<WeighStationCustomResponse[]>> {       
          return this.apiService.execute<WeighStationCustomResponse[]>( 
              `api/WeighStation/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<WeighStationFullDto[]>> {       
          return this.apiService.execute<WeighStationFullDto[]>( 
              `api/WeighStation/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<WeighStationCustomResponse[]>> {       
          return this.apiService.execute<WeighStationCustomResponse[]>( 
              `api/WeighStation/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<WeighStationFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<WeighStationFullDto>[]>( 
              `api/WeighStation/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: WeighStationCreateRequest, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: WeighStationCustomUpdateRequest, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<WeighStationCustomResponse>> {       
          return this.apiService.execute<WeighStationCustomResponse>( 
              `api/WeighStation/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ManageUsersControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getUsers_get(): Observable<ApiResponse<ApplicationUserBasicInformationResponse[]>> {       
          return this.apiService.execute<ApplicationUserBasicInformationResponse[]>( 
              `api/ManageUsers/GetUsers`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getUsersForUserManagement_get(): Observable<ApiResponse<ApplicationUserResponse[]>> {       
          return this.apiService.execute<ApplicationUserResponse[]>( 
              `api/ManageUsers/GetUsersForUserManagement`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public updateUser_put(applicationUserWithRolesUpdateRequest: ApplicationUserWithRolesUpdateRequest, form?: NgForm): Observable<ApiResponse<ApplicationUserResponse>> {       
          return this.apiService.execute<ApplicationUserResponse>( 
              `api/ManageUsers/UpdateUser`,
              HttpVerbConstants.put, applicationUserWithRolesUpdateRequest, form);
            }
    
  
    
    
  
      
  
      public deleteUser_delete(id: string, form?: NgForm): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/ManageUsers/DeleteUser/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivateUser_put(id: string, form?: NgForm): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/ManageUsers/ReactivateUser/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public getCountOfPendingUsers_get(): Observable<ApiResponse<number>> {       
          return this.apiService.execute<number>( 
              `api/ManageUsers/GetCountOfPendingUsers`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class AccountControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public logout_get(): Observable<ApiResponse<ApiUrlResponse>> {       
          return this.apiService.execute<ApiUrlResponse>( 
              `api/Account/Logout`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public updateUser_put(applicationUserUpdateRequest: ApplicationUserUpdateRequest, form?: NgForm): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/Account/UpdateUser`,
              HttpVerbConstants.put, applicationUserUpdateRequest, form);
            }
    
  
    
    
  
      
  
      public getCurrentlyAuthorizedUser_get(): Observable<ApiResponse<CurrentAuthenticatedUserResponse>> {       
          return this.apiService.execute<CurrentAuthenticatedUserResponse>( 
              `api/Account/GetCurrentlyAuthorizedUser`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getCurrentlyAuthorizedUserFromDatabase_get(): Observable<ApiResponse<CurrentAuthenticatedUserResponse>> {       
          return this.apiService.execute<CurrentAuthenticatedUserResponse>( 
              `api/Account/GetCurrentlyAuthorizedUserFromDatabase`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class RoleControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllApplicationRolesForUserManagement_get(): Observable<ApiResponse<ApplicationRoleResponse[]>> {       
          return this.apiService.execute<ApplicationRoleResponse[]>( 
              `api/Role/GetAllApplicationRolesForUserManagement`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class DriveWYZEControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public submit_post(observations: DrivewyzeObservationRequest[], form?: NgForm): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/DriveWYZE/Submit`,
              HttpVerbConstants.post, observations, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class CviewControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public searchObservations_post(SearchRequest: CviewRequest, form?: NgForm): Observable<ApiResponse<CviewPagedResponse>> {       
          return this.apiService.execute<CviewPagedResponse>( 
              `api/Cview/SearchObservations`,
              HttpVerbConstants.post, SearchRequest, form);
            }
    
  
    
    
  
      
  
      public generateObservationPdf_get(observationId: number, form?: NgForm): Observable<ApiResponse<null>> {       
          return this.apiService.execute<null>( 
              `api/Cview/GenerateObservationPdf?observationId=${observationId}`,
              HttpVerbConstants.get, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class PrePassControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public submit_post(observations: PrePassObservationRequest[], form?: NgForm): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/PrePass/Submit`,
              HttpVerbConstants.post, observations, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class KATSControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public submit_post(observation: KATSObservationRequest, form?: NgForm): Observable<ApiResponse<ObservationSubmitResponse>> {       
          return this.apiService.execute<ObservationSubmitResponse>( 
              `api/KATS/Submit`,
              HttpVerbConstants.post, observation, form);
            }
    
  
    
    
  
      
  
      public replaceImage_post(imageReplace: ImageReplaceRequest[], form?: NgForm): Observable<ApiResponse<ObservationImageSubmitResponse[]>> {       
          return this.apiService.execute<ObservationImageSubmitResponse[]>( 
              `api/KATS/ReplaceImage`,
              HttpVerbConstants.post, imageReplace, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class KYUControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public searchObservations_post(dot: number | null, kyu: number | null, fromDate: Date, toDate: Date, verified: boolean | null, form?: NgForm): Observable<ApiResponse<KyuSearchResponse[]>> {       
          return this.apiService.execute<KyuSearchResponse[]>( 
              `api/KYU/SearchObservations?dot=${dot}&kyu=${kyu}&fromDate=${fromDate}&toDate=${toDate}&verified=${verified}`,
              HttpVerbConstants.post, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ObservationsOutsideAgencyControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public searchObservations_post(dot: number, year: number, form?: NgForm): Observable<ApiResponse<ObservationsOutsideAgencyResponse[]>> {       
          return this.apiService.execute<ObservationsOutsideAgencyResponse[]>( 
              `api/ObservationsOutsideAgency/SearchObservations?dot=${dot}&year=${year}`,
              HttpVerbConstants.post, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ObservationSearchControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public searchObservations_post(searchRequest: ObservationSearchRequest, pageNumber: number | null, sortColumn: string | null, sortByDirection: string | null, form?: NgForm): Observable<ApiResponse<ObservationSearchResponse>> {       
          return this.apiService.execute<ObservationSearchResponse>( 
              `api/ObservationSearch/SearchObservations?pageNumber=${pageNumber}&sortColumn=${sortColumn}&sortByDirection=${sortByDirection}`,
              HttpVerbConstants.post, searchRequest, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ObserverControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllTypeObservers_get(): Observable<ApiResponse<ObserverResponse[]>> {       
          return this.apiService.execute<ObserverResponse[]>( 
              `api/Observer/GetAllTypeObservers`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getToday_get(): Observable<ApiResponse<string>> {       
          return this.apiService.execute<string>( 
              `api/Observer/GetToday`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ObservationDisplayControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getObservation_post(id: number, form?: NgForm): Observable<ApiResponse<ObservationDisplayResponse>> {       
          return this.apiService.execute<ObservationDisplayResponse>( 
              `api/ObservationDisplay/GetObservation?id=${id}`,
              HttpVerbConstants.post, null, form);
            }
    
  
    
    
  
      
  
      public getObservationImage_post(path: string, form?: NgForm): Observable<ApiResponse<ObservationImageResponse>> {       
          return this.apiService.execute<ObservationImageResponse>( 
              `api/ObservationDisplay/GetObservationImage?path=${encodeURIComponent(path)}`,
              HttpVerbConstants.post, null, form);
            }
    
  
    
    
  
      
  
      public generateObservationPdf_get(observationId: number, form?: NgForm): Observable<ApiResponse<null>> {       
          return this.apiService.execute<null>( 
              `api/ObservationDisplay/GenerateObservationPdf?observationId=${observationId}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public updateObservation_post(request: ObservationUpdateRequest, form?: NgForm): Observable<ApiResponse<number>> {       
          return this.apiService.execute<number>( 
              `api/ObservationDisplay/UpdateObservation`,
              HttpVerbConstants.post, request, form);
            }
    
  
    
    
  
      
  
      public getObservationHistory_post(id: number, form?: NgForm): Observable<ApiResponse<ObservationHistoryResponse>> {       
          return this.apiService.execute<ObservationHistoryResponse>( 
              `api/ObservationDisplay/GetObservationHistory?id=${id}`,
              HttpVerbConstants.post, null, form);
            }
    
  
    
    
  
      
  
      public getScreeningInfo_post(dot: string, form?: NgForm): Observable<ApiResponse<ScreeningResponse>> {       
          return this.apiService.execute<ScreeningResponse>( 
              `api/ObservationDisplay/GetScreeningInfo?dot=${encodeURIComponent(dot)}`,
              HttpVerbConstants.post, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class StatusControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllTypeStatuses_get(): Observable<ApiResponse<StatusResponse[]>> {       
          return this.apiService.execute<StatusResponse[]>( 
              `api/Status/GetAllTypeStatuses`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ViolationControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllTypeViolations_get(): Observable<ApiResponse<ViolationResponse[]>> {       
          return this.apiService.execute<ViolationResponse[]>( 
              `api/Violation/GetAllTypeViolations`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ReportControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getReportRedirectUrl_get(): Observable<ApiResponse<ReportRedirectUrlResponse>> {       
          return this.apiService.execute<ReportRedirectUrlResponse>( 
              `api/Report/GetReportRedirectUrl`,
              HttpVerbConstants.get, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class EmailsTemplateControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getEmailTemplates_get(): Observable<ApiResponse<EmailTemplateMetaDataResponse[]>> {       
          return this.apiService.execute<EmailTemplateMetaDataResponse[]>( 
              `api/EmailsTemplate/GetEmailTemplates`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<EmailTemplateResponse[]>> {       
          return this.apiService.execute<EmailTemplateResponse[]>( 
              `api/EmailsTemplate/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<EmailTemplateFullDto[]>> {       
          return this.apiService.execute<EmailTemplateFullDto[]>( 
              `api/EmailsTemplate/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<EmailTemplateResponse[]>> {       
          return this.apiService.execute<EmailTemplateResponse[]>( 
              `api/EmailsTemplate/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<EmailTemplateFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<EmailTemplateFullDto>[]>( 
              `api/EmailsTemplate/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<EmailTemplateResponse>> {       
          return this.apiService.execute<EmailTemplateResponse>( 
              `api/EmailsTemplate/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: EmailTemplateCreateRequest, form?: NgForm): Observable<ApiResponse<EmailTemplateResponse>> {       
          return this.apiService.execute<EmailTemplateResponse>( 
              `api/EmailsTemplate/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: EmailTemplateUpdateRequest, form?: NgForm): Observable<ApiResponse<EmailTemplateResponse>> {       
          return this.apiService.execute<EmailTemplateResponse>( 
              `api/EmailsTemplate/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<EmailTemplateResponse>> {       
          return this.apiService.execute<EmailTemplateResponse>( 
              `api/EmailsTemplate/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<EmailTemplateResponse>> {       
          return this.apiService.execute<EmailTemplateResponse>( 
              `api/EmailsTemplate/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class SystemAdminControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public healthCheckNotification_post(message: HealthCheckNotificationPayloadDto, form?: NgForm): Observable<ApiResponse<null>> {       
          return this.apiService.execute<null>( 
              `api/SystemAdmin/HealthCheckNotification`,
              HttpVerbConstants.post, message, form);
            }
    
  
    
    
  
      
  
      public getRecentLogs_get(includeInformationLevel: boolean, form?: NgForm): Observable<ApiResponse<LogResponse[]>> {       
          return this.apiService.execute<LogResponse[]>( 
              `api/SystemAdmin/GetRecentLogs?includeInformationLevel=${includeInformationLevel}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getRecentLogsByUserId_get(userId: string, form?: NgForm): Observable<ApiResponse<LogResponse[]>> {       
          return this.apiService.execute<LogResponse[]>( 
              `api/SystemAdmin/GetRecentLogsByUserId?userId=${userId}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public throwBadRequestException_get(): Observable<ApiResponse<null>> {       
          return this.apiService.execute<null>( 
              `api/SystemAdmin/ThrowBadRequestException`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public throwBadRequest_get(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/ThrowBadRequest`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public throwUncaughtServerError_get(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/ThrowUncaughtServerError`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public throwServerError_get(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/ThrowServerError`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public emitLoggingWarning_get(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/EmitLoggingWarning`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public emitLoggingError_get(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/EmitLoggingError`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public emitLoggingCritical_get(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/EmitLoggingCritical`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public sendTestEmail_get(emailAddress: string, form?: NgForm): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/SendTestEmail?emailAddress=${encodeURIComponent(emailAddress)}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getRecentEmails_get(emailAddress: string, form?: NgForm): Observable<ApiResponse<EmailLogFullDto[]>> {       
          return this.apiService.execute<EmailLogFullDto[]>( 
              `api/SystemAdmin/GetRecentEmails?emailAddress=${encodeURIComponent(emailAddress)}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllEmailAddressesLogged_get(): Observable<ApiResponse<string[]>> {       
          return this.apiService.execute<string[]>( 
              `api/SystemAdmin/GetAllEmailAddressesLogged`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getServerMemoryCacheContents_get(): Observable<ApiResponse<Tuple<string,any>[]>> {       
          return this.apiService.execute<Tuple<string,any>[]>( 
              `api/SystemAdmin/GetServerMemoryCacheContents`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public removeItemByKeyInMemoryCache_delete(key: string, form?: NgForm): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/SystemAdmin/RemoveItemByKeyInMemoryCache/${key}`,
              HttpVerbConstants.delete, null, form);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class GlobalMessageControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public getAllForManagement_get(): Observable<ApiResponse<GlobalMessageManageResponse[]>> {       
          return this.apiService.execute<GlobalMessageManageResponse[]>( 
              `api/GlobalMessage/GetAllForManagement`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public create_post(createRequest: GlobalMessageCreateRequest, form?: NgForm): Observable<ApiResponse<GlobalMessageResponse>> {       
          return this.apiService.execute<GlobalMessageResponse>( 
              `api/GlobalMessage/Create`,
              HttpVerbConstants.post, createRequest, form);
            }
    
  
    
    
  
      
  
      public delete_delete(id: number, form?: NgForm): Observable<ApiResponse<GlobalMessageResponse>> {       
          return this.apiService.execute<GlobalMessageResponse>( 
              `api/GlobalMessage/Delete/${id}`,
              HttpVerbConstants.delete, null, form);
            }
    
  
    
    
  
      
  
      public update_put(updateRequest: GlobalMessageUpdateRequest, form?: NgForm): Observable<ApiResponse<GlobalMessageResponse>> {       
          return this.apiService.execute<GlobalMessageResponse>( 
              `api/GlobalMessage/Update`,
              HttpVerbConstants.put, updateRequest, form);
            }
    
  
    
    
  
      
  
      public createFakeData_post(numberOfFakes: number, form?: NgForm): Observable<ApiResponse<GlobalMessageResponse[]>> {       
          return this.apiService.execute<GlobalMessageResponse[]>( 
              `api/GlobalMessage/CreateFakeData?numberOfFakes=${numberOfFakes}`,
              HttpVerbConstants.post, null, form);
            }
    
  
    
    
  
      
  
      public reactivate_put(id: number, form?: NgForm): Observable<ApiResponse<GlobalMessageResponse>> {       
          return this.apiService.execute<GlobalMessageResponse>( 
              `api/GlobalMessage/Reactivate/${id}`,
              HttpVerbConstants.put, null, form);
            }
    
  
    
    
  
      
  
      public hardDelete_post(id: number, form?: NgForm): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/GlobalMessage?id=${id}`,
              HttpVerbConstants.post, null, form);
            }
    
  
    
    
  
      
  
      public getAll_get(): Observable<ApiResponse<GlobalMessageResponse[]>> {       
          return this.apiService.execute<GlobalMessageResponse[]>( 
              `api/GlobalMessage/GetAll`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllAsEntityDto_get(includeInactive: boolean, form?: NgForm): Observable<ApiResponse<GlobalMessageFullDto[]>> {       
          return this.apiService.execute<GlobalMessageFullDto[]>( 
              `api/GlobalMessage/GetAllAsEntityDto?includeInactive=${includeInactive}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getAllInactive_get(): Observable<ApiResponse<GlobalMessageResponse[]>> {       
          return this.apiService.execute<GlobalMessageResponse[]>( 
              `api/GlobalMessage/GetAllInactive`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public getAllHistoryById_get(id: number, form?: NgForm): Observable<ApiResponse<EntitySnapshotDto<GlobalMessageFullDto>[]>> {       
          return this.apiService.execute<EntitySnapshotDto<GlobalMessageFullDto>[]>( 
              `api/GlobalMessage/GetAllHistoryById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public getById_get(id: number, form?: NgForm): Observable<ApiResponse<GlobalMessageResponse>> {       
          return this.apiService.execute<GlobalMessageResponse>( 
              `api/GlobalMessage/GetById/${id}`,
              HttpVerbConstants.get, null, form);
            }
    
  
  
  
  }


@Injectable({
  providedIn: 'root',
})
export class AuthenticationControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  
  
    
    
  
      
  
      public login_get(returnUrl: string | null, form?: NgForm): Observable<ApiResponse<null>> {       
          return this.apiService.execute<null>( 
              `api/Authentication/Login?returnUrl=${returnUrl}`,
              HttpVerbConstants.get, null, form);
            }
    
  
    
    
  
      
  
      public isCurrentUserAuthenticated_get(): Observable<ApiResponse<boolean>> {       
          return this.apiService.execute<boolean>( 
              `api/Authentication/IsCurrentUserAuthenticated`,
              HttpVerbConstants.get, null);
            }
    
  
    
    
  
      
  
      public requestAccess_post(): Observable<ApiResponse<ApiMessageResponse>> {       
          return this.apiService.execute<ApiMessageResponse>( 
              `api/Authentication/RequestAccess`,
              HttpVerbConstants.post, null);
            }
    }


@Injectable({
  providedIn: 'root',
})
export class ApiControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  }


@Injectable({
  providedIn: 'root',
})
export class VendorApiControllerService {
  constructor(private apiService: ApiService){}
  public form?: NgForm
    
  }


//#endregion



